export default __webpack_public_path__ + "static/media/incentiveLoyalty.f889327a.jpg";